<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>

import { PROJECT_NAME } from '@/constant/config'

export default {
  name: 'App',
  watch: {
    '$store.state.AMap': {
      handler(AMap) {
        if (AMap) {
          this.$store.commit('setGeolocation')
        }
      },
      immediate: true
    }
  },
  created() {
    document.title = PROJECT_NAME
  },
  mounted() {
    this.$store.commit('setAMap')
  }
}
</script>
<style lang="less">
#app {
  height: 100%;
  background: #F6F5F5;
}
</style>
